import React from 'react';

const OrderLogManagement = () => {
  return (
    <h1>Order Log Management</h1>
  )
}
export default OrderLogManagement;